import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SignaturePadComponent, NgSignaturePadOptions } from '@almothafar/angular-signature-pad';
import { UtilService } from 'src/app/services/util.service';

@Component({
	selector: 'app-sign-pad',
	templateUrl: './sign-pad.component.html',
	styleUrls: ['./sign-pad.component.scss']
})
export class SignPadComponent implements AfterViewInit {

	signature: File;
	@Output() onSignatureComplete = new EventEmitter<any>();

	@ViewChild('signature')
	public signaturePad: SignaturePadComponent;

	signaturePadOptions: NgSignaturePadOptions = {
		minWidth: 5,
		canvasWidth: 350,
		canvasHeight: 250
	};

	constructor(private utilService: UtilService) { }

	ngAfterViewInit() {
		this.signaturePad.set('minWidth', 5);
		if (!this.signature) {
			this.clear();
		}
	}

	@Input() 
	set file(file: File) {
		this.signature = file;
		this.getBase64();
	}


	drawComplete(event: MouseEvent | Touch) {
		let file = new File([this.utilService.dataURItoBlob(this.signaturePad.toDataURL())], 'signature.png', { type: "image/png" });
		this.onSignatureComplete.emit({ 'signature': file });
	}

	drawStart(event: MouseEvent | Touch) {
	}

	clear() {
		this.signaturePad.clear();
	}

	private getBase64() {
		if (!this.signature) {
			return;
		}
		var reader = new FileReader();
		reader.readAsDataURL(this.signature);
		reader.onload = e => {
			console.log('Signature: ' + <string>e.target.result);
			this.signaturePad.fromDataURL(<string>e.target.result);
		}
		
		reader.onerror = function (error) {
			console.log('Error: ', error);
		};
	}
}